export function ApplicationModules() {
    return [
        { name: 'Assets', value: 'assets' },
        { name: 'Beta Tester', value: 'beta_tester' },
        { name: 'Custom Reports', value: 'custom_reports' },
        { name: 'Documents', value: 'documents' },
        { name: 'Public API', value: 'public_api' },
    ];
}
